import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { MAX_SIZE_20_MB } from 'src/app/consts/size.consts';
import { FileService } from 'src/app/services/file.service';

@Component({
  selector: 'app-file-input',
  templateUrl: './file-input.component.html',
  styleUrls: ['./file-input.component.css'],
  standalone: false
})
export class FileInputComponent {
  @Output()
  uploadFileEvent = new EventEmitter<Event>();

  @Output()
  removeFileEvent = new EventEmitter<string>();

  @Input()
  files!: { fileName: string; url: string }[];

  @Input()
  supportedExtensions: string[] = [];

  @Input()
  maxSize: number = MAX_SIZE_20_MB;

  fileService = inject(FileService);

  openFile(url: string): void {
    window.open(url);
  }

  uploadFile($event: Event): void {
    if (this.fileService.checkMaxSizeExceeded($event, this.maxSize)) return;
    this.uploadFileEvent.emit($event);
  }
}
